module.exports = __webpack_public_path__ + "img/bg-accident-item-1.71d5be92.png";